import { callBackendFunction } from './paymentService';

export interface PublishOutingResponse {
  status: 'published' | 'already_published';
  outingId: string;
  publishedAt: string | null;
}

export interface OutingPublicationAnnouncementPreviewResponse {
  outingId: string;
  publicationStatus: 'published' | 'draft';
  emailTargetCount: number;
  pushUserTargetCount: number;
  pushTokenTargetCount: number;
  canSendEmail: boolean;
  canSendPush: boolean;
}

export interface OutingPublicationAnnouncementSummary {
  emailTargeted: number;
  emailSucceeded: number;
  emailFailed: number;
  pushTargeted: number;
  pushSucceeded: number;
  pushFailed: number;
}

export interface SendOutingPublicationAnnouncementResponse {
  status: 'sent' | 'already_sent';
  outingId: string;
  publicationAnnouncementStatus: 'completed' | 'partial_failed' | 'failed';
  publicationAnnouncementSentAt: string | null;
  publicationAnnouncementSummary: OutingPublicationAnnouncementSummary;
}

export const outingPublicationService = {
  async publishOuting(outingId: string) {
    return callBackendFunction<{ outingId: string }, PublishOutingResponse>('publishOuting', { outingId });
  },

  async previewOutingPublicationAnnouncement(outingId: string) {
    return callBackendFunction<{ outingId: string }, OutingPublicationAnnouncementPreviewResponse>('previewOutingPublicationAnnouncement', { outingId });
  },

  async sendOutingPublicationAnnouncement(outingId: string) {
    return callBackendFunction<{ outingId: string }, SendOutingPublicationAnnouncementResponse>('sendOutingPublicationAnnouncement', { outingId });
  },
};